import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberCertificationsPage from "@/pages/member/MemberCertificationsPage";

export const Route = createFileRoute("/member/certifications")({
  head: () => pageHead("Member · Certifications", "AKIVA member · certifications portal.", "/member/certifications", true),
  component: MemberCertificationsPage,
});
